export default __webpack_public_path__ + "static/project2-437d726298924b591efe1f756576b184.jpg";